import { useContext, useEffect } from 'react'
import { NavContext } from '../../context/global_context'
import { createSearchParams } from 'react-router-dom'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import UserList from '../../components/administration/user'
import PlantList from '../../components/administration/plant'
import TestZones from '../../components/administration/test_zones'
import TestZoneStore from '../../components/administration/test_zones/context/context'
import ShiftStore from '../../components/administration/shifts/context/context'
import Shifts from '../../components/administration/shifts'
import { getSessionStorageData } from '../../utils/SessionStorage'
import Customer from '../../components/administration/customer'
import CustomerStore from '../../components/administration/customer/context/context'
import AppsStore from '../../components/administration/apps/context/context'
import OAuthApps from '../../components/administration/apps'
import { USER_MANAGEMENT } from '../../constants/permission'

const Administration = () => {
  const [value, dispatch] = useContext(NavContext)
  const vehicle_redirect_url = getSessionStorageData('vehicle')?.search
    ? `/vehicles/?${createSearchParams(getSessionStorageData('vehicle'))}`
    : `/vehicles`

  useEffect(() => {
    dispatch({
      type: 'header',
      data: {
        header: 'Administration',
        sub_header: 'Here you can modify or create user, plant, test zones',
        id: '',
        show_back_btn: true,
        dtc_details: {},
        vehicle: '',
        back_btn_url: vehicle_redirect_url,
        full_width_container: false,
      },
    })
  }, [])

  return (
    <Tabs variant="fullWidth" style={{ width: '100%' }}>
      <TabList style={{ fontSize: '1.25rem' }}>
        {value?.permissions?.includes(USER_MANAGEMENT) && <Tab>Users</Tab>}
        <Tab>Plants</Tab>
        <Tab>Test Zones</Tab>
        <Tab>Shifts</Tab>
        <Tab>Apps</Tab>
        <Tab>Customer</Tab>
      </TabList>
      {value?.permissions?.includes(USER_MANAGEMENT) && (
        <TabPanel>
          <div className="w-full text-white ">
            {value?.header && <UserList />}
          </div>
        </TabPanel>
      )}

      <TabPanel>
        <div className="w-full text-white block">
          {value?.header && <PlantList />}
        </div>
      </TabPanel>
      <TabPanel>
        <div className="w-full text-white block">
          {value?.header && (
            <TestZoneStore>
              <TestZones />
            </TestZoneStore>
          )}
        </div>
      </TabPanel>

      <TabPanel>
        <div className="w-full text-white block">
          {value?.header && (
            <ShiftStore>
              <Shifts />
            </ShiftStore>
          )}
        </div>
      </TabPanel>
      <TabPanel>
        <div className="w-full text-white block">
          {value?.header && (
            <AppsStore>
              <OAuthApps />
            </AppsStore>
          )}
        </div>
      </TabPanel>
      <TabPanel>
        <div className="w-full text-white block">
          {value?.header && (
            <CustomerStore>
              <Customer />
            </CustomerStore>
          )}
        </div>
      </TabPanel>
    </Tabs>
  )
}

export default Administration
